import { Col, Row, Select } from 'antd';
import React, {Fragment, useState} from 'react';
import StringDownloadButton from '../../components/string-download-button';
import { GUTTER_MD, MARGIN_MD } from '../../styles/constants';
import { getExceptionError, getExceptionReport, ReportError } from './ReportError';
import { getReportInfoListStr, ReportInfoList } from './ReportInfoList';
import ReportWarningList, { getReportWarningListStr, getReportWrongLinesStr } from './ReportWarningList';

const ReportContent = ({
  t,
  reportFileNameId,
  reportFileNameTime,
  reportComponents,
  resultItems
}) => {


  const [selectedItemIdx, setSelectedItemIdx] = useState(0);
  const [selectedComponent, setSelectedComponent] = useState(reportComponents[0]);

  const handleSelectChange = (index) => {
    setSelectedItemIdx(index);
    setSelectedComponent(reportComponents[index]);
  }

  return (

    <Fragment>
        {(resultItems || []).length > 0 && (
        <Row type="flex" justify="end">
          <Col>
          <Select 
            value={selectedItemIdx} 
            onSelect={(index) => handleSelectChange(index)} 
            size="large"
          >
            {(resultItems || []).map((item, index) =>
              <Select.Option 
                key={index} 
                value={index}
              >                    
                {item}
              </Select.Option>
            )}
          </Select>
          </Col>
        </Row>
        )}
        {
          selectedComponent.exception 
           ?
           <Fragment>
              <ReportError
                t={t}
                exception={selectedComponent.exception}
            />
              { getExceptionError(t, selectedComponent.exception) && (
                <Row type="flex" justify="end" style={{marginTop: MARGIN_MD}} gutter={GUTTER_MD}>
                  <Col>
                  <StringDownloadButton
                    str={`${getReportWarningListStr(t, getExceptionReport(selectedComponent.exception))}`}
                      fileName={`report_${reportFileNameId ? `${reportFileNameId}_` : ''}${reportFileNameTime}.txt`}
                      mimeType="text/plain"
                  >
                      {t('middlewares.feedback.buttons.errorDownload')}
                  </StringDownloadButton>
                  </Col>
              </Row>
              )}
            </Fragment>
           : <Fragment>
                <ReportInfoList t={t} infos={selectedComponent.ReportDictionary}/>
                <div style={{marginTop: MARGIN_MD}}>
                    <ReportWarningList t={t} warnings={selectedComponent.WarnDictionary}/>
                </div>
                <Row type="flex" justify="end" style={{marginTop: MARGIN_MD}} gutter={GUTTER_MD}>
                  <Col>
                  <StringDownloadButton
                      str={`${getReportInfoListStr(t, selectedComponent.ReportDictionary)}\r\n${getReportWarningListStr(t, selectedComponent.WarnDictionary)}`}
                      fileName={`report_${reportFileNameId ? `${reportFileNameId}_` : ''}${reportFileNameTime}.txt`}
                      mimeType="text/plain"
                  >
                      {t('middlewares.feedback.buttons.warningListDownload')}
                  </StringDownloadButton>
                  </Col>
                  {selectedComponent.WrongLines && selectedComponent.WrongLines.length > 0 && (
                    <Col>
                        <StringDownloadButton
                        str={getReportWrongLinesStr(selectedComponent.WrongLines)}
                        fileName={`wrong-lines_${reportFileNameId ? `${reportFileNameId}_` : ''}${reportFileNameTime}.csv`}
                        mimeType="text/csv"
                        >
                        {t('middlewares.feedback.buttons.wrongLinesDownload')}
                        </StringDownloadButton>
                    </Col>
                  )}
                </Row>
            </Fragment>
        }
        
    </Fragment>
  
  );
}

export default ReportContent;